import { Types } from "assets/theme/base/spacing";
import { HMO, HMOType } from "constants/hmo";

/**
 * HMO Spacing Overrides
 * Defines spacing customizations for each HMO portal
 * 
 * React 19 Best Practice: Pre-computed module-level constants
 * Since HMO is detected once and never changes, we pre-compute all possible values
 * This eliminates runtime computation and aligns with React 19's immutable patterns
 */

// Pre-computed HMO spacing constants (React 19 best practice - compile-time constants)
const HMO_SPACING: Record<HMO, Partial<Types>> = {
  [HMO.LEUMIT]: {
    // Leumit-specific spacing overrides can be added here
    // Example: md: pxToRem(18), spacing10: pxToRem(22), etc.
  },

  [HMO.MACCABI]: {
    // Macabi-specific spacing overrides can be added here
  },

  [HMO.CLALIT]: {
    // Clalit-specific spacing overrides can be added here
  },

  [HMO.MEUCHEDET]: {
    // Meuchedet-specific spacing overrides can be added here
  },
  [HMO.CLINICAL_TRIAL]: {
    // Trial-specific spacing overrides can be added here
  },
};

// Default (no HMO) - empty object
const DEFAULT_SPACING: Partial<Types> = {};

/**
 * Returns HMO-specific spacing overrides (React 19 best practice - O(1) lookup from pre-computed constants)
 * @param hmo - HMO identifier or null for default
 * @returns HMO spacing overrides or empty object for default theme
 */
export function getHmoSpacing(hmo: HMOType): Partial<Types> {
  if (!hmo) {
    return DEFAULT_SPACING;
  }
  
  return HMO_SPACING[hmo] || DEFAULT_SPACING;
}












